<template>
  <v-card :loading="loading" class="px-5">

    <!-- Bouton partager url -->
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab small class="v-btn--share d-print-none" v-bind="attrs" v-on="on" v-show="!loading"><v-icon>mdi-share-variant</v-icon></v-btn>
      </template>
      <v-card>
        <v-card-title class="grey lighten-2">
          Partager la fiche
        </v-card-title>
        <!-- nécessaire pour pouvoir copier l'url dans le presse papier -->
        <v-text-field :value="url" ref="url" type="texte" dense class="ma-5"></v-text-field>
        <v-divider></v-divider>
        <v-card-actions justify>
          <v-spacer></v-spacer>
          <v-btn text @click="onClickCopyUrl">Copier le lien</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Indicateur de chargement  -->
    <v-row v-show="loading">
      <v-col cols="12" class="pa-5">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        Veuillez patienter...
      </v-col>
    </v-row>

    <!-- Fiche  -->
    <v-row v-show="!loading">
      <v-col>
        <v-btn :to="'/listeorganisme'" class="d-print-none"><v-icon left>mdi-arrow-left</v-icon>Retour à la liste</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>{{ libelle }}</h2>
        <div v-html="activite" class="grey--text text--darken-1 pt-1" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <img :src="avatar" height="200" contain @error="onImageError">
      </v-col>
      <v-col cols="12" md="3">
        <h3><v-icon left>mdi-account</v-icon>Contact</h3>
        <div class="grey--text pt-1">{{ adressePrincipale.contact.civilite }} {{ adressePrincipale.contact.nom }} {{ adressePrincipale.contact.prenom }}</div>
        <div class="grey--text pt-1"    v-if="telephone != ''"><v-icon left small>mdi-phone</v-icon>{{ telephone }}</div>
        <div class="grey--text pt-1"     v-if="courriel != ''"><v-icon left small>mdi-email</v-icon>{{ courriel }}</div>
        <div class="grey--text pt-1" v-if="siteInternet != ''"><v-icon left small>mdi-web  </v-icon><a :href="'http://' + siteInternet" target="_blank">{{ siteInternet }}</a></div>
      </v-col>
      <v-col cols="12" md="3">
        <h3><v-icon left>mdi-map-marker</v-icon>Localisation</h3>
        <div class="grey--text pt-1">{{ adresse1 }}</div>
        <div class="grey--text pt-1">{{ adresse2 }}</div>
        <div class="grey--text pt-1">{{ adresse3 }}</div>
        <div class="grey--text pt-1">{{ codePostal }} {{ ville }}</div>
      </v-col>
      <v-col cols="12" md="3">
        <h3><v-icon left>mdi-newspaper-variant</v-icon>Informations</h3>
        <div class="grey--text pt-1" v-if="secteurActivite != ''"><v-icon left small>mdi-factory      </v-icon><span class="font-weight-bold">Secteur d'activité:</span> {{ secteurActivite }}</div>
        <div class="grey--text pt-1"         v-if="codeNaf != ''"><v-icon left small>mdi-tag          </v-icon><span class="font-weight-bold">Code NAF:          </span> {{ codeNaf }}        </div>
        <div class="grey--text pt-1"    v-if="dateCreation != ''"><v-icon left small>mdi-calendar     </v-icon><span class="font-weight-bold">Date de création:  </span> {{ dateCreation }}   </div>
        <div class="grey--text pt-1" v-if="statutJuridique != ''"><v-icon left small>mdi-scale-balance</v-icon><span class="font-weight-bold">Statut juridique:  </span> {{ statutJuridique }}</div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  'use strict'

  import Objet     from '../objet.js'

  export default {
    props : {
      propId : String
    },
    data(){
      return {
        // Propriété JSON du webservice
        activite         : '',
        adresse1         : '',
        adresse2         : '',
        adresse3         : '',
        adressePrincipale: {
          contact : {
            civilite: '',
            nom: '',
            prenom: ''
          },
          courriel: ''
        },
        avatar           : '',
        codeNaf          : '',
        codePostal       : '',
        courriel         : '',
        dateCreation     : '',
        libelle          : '',
        secteurActivite  : '',
        siteInternet     : '',
        statutJuridique  : '',
        telephone        : '',
        ville            : '',
        // Autres data pour le fonctionnement de la fiche
        dialog : false,                // Statut d'affichage de la popup pour copier l'url
        loading: true,                 // Indicateur de chargement
        url    : window.location.href, // Saisie l'url de la fiche dans un champ input (Nécessaire pour pouvoir copier l'url dans le presse papier)
      }
    },
    /**
     * Retrouve l'organisme à partir de l'id indiqué dans l'url
     */
    mounted(){
      var that = this

      this.loading = true
      this.$store.dispatch('organisme/fiche', this.propId)
      .then(function(){
        that.loading = false
        var org = that.$store.getters['organisme/fiche']
        if (!org.id){
          org.libelle = "Organisme introuvable"
        }
        Objet.copy(org, that.$data) // Ecrase les données du composant pour actualiser la vue
      })
    },
    methods:{
      /**
       * Gère le cas des erreurs 404 pour les images
       */
      onImageError(){
        this.avatar = require('../assets/404.jpg')
      },
      /**
       * Copie l'url de la fiche dans le presse papier à des fins de partage
       */
      onClickCopyUrl(){
        this.$refs.url.$el.querySelector('input').select() // Sélectionne l'url dans l'input
        document.execCommand("copy")
        this.dialog = false // Cache la popup
      }
    },
  }
</script>

<style scoped>
  .v-btn--share{
    position: absolute;
    top     : 10px;
    right   : 10px;
    z-index : 1;
  }
</style>